import { render, staticRenderFns } from "./PurchaseEditSelectContact.vue?vue&type=template&id=4c814e5c&scoped=true"
import script from "./PurchaseEditSelectContact.vue?vue&type=script&lang=ts"
export * from "./PurchaseEditSelectContact.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseEditSelectContact.vue?vue&type=style&index=0&id=4c814e5c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c814e5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c814e5c')) {
      api.createRecord('4c814e5c', component.options)
    } else {
      api.reload('4c814e5c', component.options)
    }
    module.hot.accept("./PurchaseEditSelectContact.vue?vue&type=template&id=4c814e5c&scoped=true", function () {
      api.rerender('4c814e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseEditSelectContact.vue"
export default component.exports